export default __webpack_public_path__ + "static/media/copy.a1fd82de.svg";